import { useFormikContext } from 'formik';
import { useContext } from 'react';

import { Button } from '../../../../cdl/Button/Button';
import { FormikInput } from '../../../../cdl/Input/FormikInput';
import { Text } from '../../../../cdl/Text/Text';
import { ButtonGroup } from '../../../../common/buttons/ButtonGroup';
import { translate } from '../../../../common/helpers/translate.helper';
import { IconArrowLeft } from '../../../../common/icons/cdl/ArrowLeft';
import { Box } from '../../../../common/ui/Box';

import { ContinueButton } from './ContinueButton';
import { CreateWebhookContext } from './CreateWebhookContext';
import { CreateWebhookFormState, CreateWebhookFormSteps } from './CreateWebhookModalContent';
import { WebhookFormButtonArea } from './WebhookFormButtonArea';

export const FormikWebhookConfigureDestination = () => {
    const { setActiveFormStep } = useContext(CreateWebhookContext);
    const { isSubmitting, submitForm, isValid } = useFormikContext<CreateWebhookFormState>();
    return (
        <Box display="grid" gap={16}>
            <Box display="grid" gap={8}>
                <Text variant="title">{translate('webhooks.configureDestination.title')}</Text>
                <Text variant="small">{translate('webhooks.configureDestination.description')}</Text>
            </Box>

            <FormikInput name="name" label={translate('webhooks.configureDestination.destinationName')} />
            <FormikInput
                name="url"
                label={translate('webhooks.configureDestination.endpointUrl')}
                caption={translate('webhooks.configureDestination.endpointUrlCaption')}
                placeholder={translate('webhooks.configureDestination.httpsUrl')}
            />

            <WebhookFormButtonArea>
                <ButtonGroup>
                    <Button
                        type="button"
                        onClick={() => setActiveFormStep(CreateWebhookFormSteps.DECIDE_TRIGGERS)}
                        LeadingIcon={IconArrowLeft}
                    >
                        {translate('btn.back')}
                    </Button>
                    <ContinueButton type="button" disabled={!isValid} isLoading={isSubmitting} onClick={submitForm} />
                </ButtonGroup>
            </WebhookFormButtonArea>
        </Box>
    );
};
